import GetShopSuppliersRequestModelBase from '../_generated/modelBases/get-shop-suppliers-request-model-base';

export default class GetShopSuppliersRequestModel extends GetShopSuppliersRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
